/*
 * Layout for the tenant profile section
 */

define(["marionette", "./template/tenantProfileTemplate.html"], function (
  Marionette,
  TenantProfileTemplate,
) {
  var TenantProfileView = {
    tenantProfileLayout: Marionette.Layout.extend({
      template: TenantProfileTemplate,
      tagName: "div",
      className: "row-fluid max-height",
      regions: {
        sideMenu: "#tenantMenu",
        tenantProfile: "#tenantProfile",
      },
    }),
  };

  return TenantProfileView;
});
